import { render } from "./productsAddNewPatternDialog.vue?vue&type=template&id=580d5422"
import script from "./productsAddNewPatternDialog.vue?vue&type=script&lang=js"
export * from "./productsAddNewPatternDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__